export default {
    selectBankList: "/gateway/huilianOperation/cashOutcs/selectBankList", // 银行网点列表查询
    createBankInfo: "/gateway/huilianCust/hcAccountBankInfocs/createBankInfo", // 银行卡绑定
};



// WEBPACK FOOTER //
// ./src/bindBank/index/api.js